import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import useBreakpoints from '@hooks/useBreakpoints';
import useTheme from '@hooks/useTheme';
import { injectTestId } from '@cvent/nucleus-test-automation';
import Menu from '@cvent/carina/components/Menu';
import { Placements } from '@cvent/carina/components/Popover';
import { useTranslate } from 'nucleus-text';
import Icon from '@components/shared/Icon';
import Typography from '@cvent/blocks/components/Typography';
import useStyles from './useStyles';

/**
 * Component to display notification flyout header
 */
const NotificationFlyoutHeader = ({
  onClose,
  actions,
  testID,
  onSelectAction
}) => {
  const { isMobile } = useBreakpoints();
  const theme = useTheme();
  const styles = useStyles({ theme, isMobile });
  const { translate } = useTranslate();
  const triggerRef = useRef();
  return (
    <div css={styles.container} {...injectTestId(testID)}>
      <Typography
        as="h2"
        styledAs="h3"
        css={styles.notificationTitle}
        {...injectTestId(`${testID}-title`)}
      >
        {translate('Notifications-Flyout-Header-Title')}
      </Typography>
      <Menu
        testID={`${testID}-menu`}
        options={actions}
        id="notifications-menu"
        onSelect={onSelectAction}
        placement={Placements.bottomEnd}
        onClose={() => {
          triggerRef.current.focus();
        }}
        trigger={(toggleOpen, isOpen) => (
          <button
            ref={triggerRef}
            aria-expanded={isOpen}
            css={styles.actionButton}
            onClick={toggleOpen}
            aria-label={translate('Notification-Menu')}
            {...injectTestId(`${testID}-actionButton`)}
            aria-haspopup="true"
            aria-controls="notifications-menu"
            id="flyout-header-menu-button"
          >
            <Icon name="more-vertical" size="md" aria-hidden />
          </button>
        )}
      />
      {isMobile && (
        <button
          css={styles.close}
          onClick={onClose}
          aria-label={translate('Notification-List-Close')}
          {...injectTestId(`${testID}-close`)}
        >
          <Icon name="close" size="md" aria-hidden />
        </button>
      )}
    </div>
  );
};

NotificationFlyoutHeader.propTypes = {
  onClose: PropTypes.func,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
    })
  ),
  testID: PropTypes.string,
  onSelectAction: PropTypes.func
};

export default NotificationFlyoutHeader;
